// Sleepify Starter Theme by Sleepless Media
//
// Main Javascript entry file.

console.log(
	'%c This site was designed & developed by https://www.sleeplessmedia.com',
	'background:#000; color: #ae956e; padding: 10px 15px; font-size: 13px; font-weight: 500; width: 100%;'
);

// Cookies functions
function setCookie(cookieName, cookieValue) {
	var today = new Date();
	var expire = new Date();
	expire.setTime(today.getTime() + 3600000 * 24 * 7);
	document.cookie =
		cookieName +
		'=' +
		encodeURI(cookieValue) +
		';expires=' +
		expire.toGMTString();
}

function getCookie(cname) {
	let name = cname + '=';
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
}

function generateTabs(tabSection){
	var $template = tabSection.find('.homepageTabs__tab--template');
	var $tabContainer = tabSection.find('.homepageTabs__tabs');
	
	tabSection.find('.tabContent').each(function(){
		var tabHTML = $template.clone().removeClass('homepageTabs__tab--template').text($(this).data('tab')).attr('data-tab', $(this).data('tab'));
		$tabContainer.append(tabHTML);
	});

	tabSection.find('.tabContent').first().show();
	tabSection.find('.homepageTabs__tab:not(.homepageTabs__tab--template)').first().addClass('homepageTabs__tab--active');
}

function bindTabs(outerContainer){
	outerContainer.find('.homepageTabs__tab').on('click', function(){
		var tab = $(this).data('tab');
		$(this).closest('.homepageTabs').find('.tabContent').hide();
		$(this).closest('.homepageTabs').find('.tabContent[data-tab="' + tab + '"]').show();
		$(this).closest('.homepageTabs').find('.homepageTabs__tab').removeClass('homepageTabs__tab--active');
		$(this).addClass('homepageTabs__tab--active');
	});
}

var mobileTabDotTemplate = `<button class="homepageTabsMobile__dot" data-index="{{index}}" data-image="{{image}}" data-hover-image="{{hoverImage}}" data-href="{{href}}" data-title="{{title}}"></button>`;
function initMobileTabs(outerContainer){
	outerContainer.find('.homepageTabsMobile__dotFlex').empty();
	outerContainer.find('.homepageTabs__bottom > .shopify-block').first().find('.tabContent .cardLink__inner').each(function(index){
		var thisHTML = mobileTabDotTemplate.replace('{{index}}', index).replace('{{image}}', $(this).find('.cardLink__image').attr('src')).replace('{{hoverImage}}', $(this).find('.cardLink__hoverImage').attr('src')).replace('{{href}}', $(this).find('.cardLink__inner').attr('href')).replace('{{title}}', $(this).find('.cardLink__title').text());
		outerContainer.find('.homepageTabsMobile__dotFlex').append(thisHTML);
	});
	outerContainer.find('.homepageTabsMobile__dot').first().addClass('homepageTabsMobile__dot--active');

	outerContainer.find('.homepageTabsMobile__select').empty();
	outerContainer.find('.homepageTabs__tab').each(function(){
		if ($(this).data('tab') !== 'template') {
			outerContainer.find('.homepageTabsMobile__select').append('<option value="' + $(this).data('tab') + '">' + $(this).data('tab') + '</option>');
		}
	});

	var firstDot = outerContainer.find('.homepageTabsMobile__dot').first();
	var thisCard = outerContainer.find('.homepageTabsMobile__card');
	thisCard.find('.cardLink__inner').attr('href', firstDot.data('href'));
	thisCard.find('.cardLink__image').attr('src', firstDot.data('image'));
	thisCard.find('.cardLink__hoverImage').attr('src', firstDot.data('hoverImage'));
	thisCard.find('.cardLink__title').text(firstDot.data('title'));
}

function bindTabsDots(outerContainer){
	outerContainer.find('.homepageTabsMobile__dot').on('click', function(){
		setTabsActiveCard(outerContainer, $(this).data('index'));
	});
}

function swapTabsCard(outerContainer, index){
	var activeDot = outerContainer.find('.homepageTabsMobile__dot.homepageTabsMobile__dot--active');
	var thisCard = outerContainer.find('.homepageTabsMobile__card');
	thisCard.find('.cardLink__inner').attr('href', activeDot.data('href'));
	thisCard.find('.cardLink__image').attr('src', activeDot.data('image'));
	thisCard.find('.cardLink__hoverImage').attr('src', activeDot.data('hoverImage'));
	thisCard.find('.cardLink__title').text(activeDot.data('title'));
}

function bindTabsSelect(outerContainer){
	outerContainer.find('.homepageTabsMobile__select').on('change', function(){
		var tabName = $(this).val();
		swapTabsDots(outerContainer, tabName);
		swapTabsCard(outerContainer, 0);
	});
}

function swapTabsDots(outerContainer, tabName){
	outerContainer.find('.homepageTabsMobile__dotFlex').empty();
	outerContainer.find('.homepageTabs__bottom > .shopify-block > .tabContent[data-tab="' + tabName + '"] .cardLink__inner').each(function(index){
		var thisHTML = mobileTabDotTemplate.replace('{{index}}', index).replace('{{image}}', $(this).find('.cardLink__image').attr('src')).replace('{{hoverImage}}', $(this).find('.cardLink__hoverImage').attr('src')).replace('{{href}}', $(this).find('.cardLink__inner').attr('href')).replace('{{title}}', $(this).find('.cardLink__title').text());
		outerContainer.find('.homepageTabsMobile__dotFlex').append(thisHTML);
	});
	outerContainer.find('.homepageTabsMobile__dot').first().addClass('homepageTabsMobile__dot--active');
	bindTabsDots(outerContainer);
}

function setTabsActiveCard(outerContainer, index){
	outerContainer.find('.homepageTabsMobile__dot').removeClass('homepageTabsMobile__dot--active');
	outerContainer.find('.homepageTabsMobile__dot').eq(index).addClass('homepageTabsMobile__dot--active');
	swapTabsCard(outerContainer, index);
}

function bindTabsArrows(outerContainer){
	var dotCount = outerContainer.find('.homepageTabsMobile__dot').length;
	outerContainer.find('.homepageTabsMobile__arrow-prev').on('click', function(){
		var activeDot = parseInt(outerContainer.find('.homepageTabsMobile__dot.homepageTabsMobile__dot--active').attr('data-index'));
		var prevIndex = activeDot - 1;
		if (prevIndex >= 0) {
			setTabsActiveCard(outerContainer, prevIndex);
		}
		else{
			setTabsActiveCard(outerContainer, dotCount - 1);
		}
	});
	outerContainer.find('.homepageTabsMobile__arrow-next').on('click', function(){
		var activeDot = parseInt(outerContainer.find('.homepageTabsMobile__dot.homepageTabsMobile__dot--active').attr('data-index'));
		var nextIndex = activeDot + 1;
		if (nextIndex < dotCount) {
			setTabsActiveCard(outerContainer, nextIndex);
		}
		else{
			setTabsActiveCard(outerContainer, 0);
		}
	});
}

var mobileLocationTemplate = `<a class="homepageLocationsMobile__item" href="{{href}}">
    <div class="homepageLocationMobile__inner">
		<div class="homepageLocationMobile__title">
			{{title}}
		</div>
		<div class="homepageLocationMobile__address">
			{{address}}
		</div>
	</div>
</a>`;

function initMobileLocations(outerContainer){
	outerContainer.find('.homepageLocations__mobile').empty();
	outerContainer.find('.homepageLocations__content .locationCard__inner').each(function(){
		var thisHTML = mobileLocationTemplate.replace('{{href}}', $(this).attr('href')).replace('{{title}}', $(this).find('.locationCard__title').text()).replace('{{address}}', $(this).find('.locationCard__address').text());
		outerContainer.find('.homepageLocations__mobile').append(thisHTML);
	});
}

function bindMobileNavAccordions(){
	$('.footer__mobileNavAccordionButton').on('click', function(){
		$(this).closest('.footer__mobileNavAccordionWrapper').toggleClass('footer__mobileNavAccordionWrapper--active');
		$(this).parent().find('.footer__mobileNavAccordionContent').slideToggle();
	});
}

function bindAnchors(){
	var headerOffset = 70; 

  $('a[href^="#"]').on('click', function(e) {
    e.preventDefault();

    var target = this.hash;
    var $target = $(target);

    if ($target.length) {
      $('html, body').animate({
        scrollTop: $target.offset().top - headerOffset
      }, 600); // adjust 600 for scroll speed (ms)
    }
  });
}

jQuery(document).ready(function ($) {
	// initialize tabs for homepageTabs.liquid
	$('.homepageTabs').each(function(){
		generateTabs($(this));
		bindTabs($(this));
		initMobileTabs($(this));
		bindTabsDots($(this));
		bindTabsSelect($(this));
		bindTabsArrows($(this));
	});

	$('.homepageLocations').each(function(){
		initMobileLocations($(this));
	});
	
	bindMobileNavAccordions();
	bindAnchors();
});